import picturefill from 'picturefill'
import objectFitImages from 'object-fit-images'
import SmoothScroll from 'smooth-scroll'
import { slideDown, slideUp, slideStop } from 'slide-anim'

import Events from '~/common/Events'
import { next } from '~/common/utils'
import Navigation from '~/modules/Navigation'
import MoreList from '~/modules/MoreList'
import YouTubePlayer from '~/modules/YouTubePlayer'
import Modal from '~/modules/Modal'

document.addEventListener('DOMContentLoaded', () => {
  // pictureタグを使用する
  picturefill()

  // cssのobject-fitを使用する
  const objectFitElm = document.querySelectorAll('.js-object-fit')
  objectFitImages(objectFitElm)

  // ナビゲーション
  new Navigation()

  /**
   * もっと見るボタン
   * 'data-more-num'で初期表示したい数を設定
   */
  ;[...document.querySelectorAll('.js-more-item')].map((el) => {
    const item = el.dataset.moreNum
    new MoreList(item)
  });

  /**
   * 大阪 年会・都度会員フォームの参加者数・合計金額の自動計算処理
   */
  if(document.querySelector('.js-count-member')){
    /**
     * 参加者名の入力に合わせてCounter更新
     * inputArrayの初期値は、必須項目の参加者①（participant01_name）
     */
    let inputArray = ['participant01_name'];
    ;[...document.querySelectorAll('.js-more-item')].map((_,i) => {
      const inputName = document.querySelector(`input[name="participant${String(i+1).padStart(2, '0')}_name"]`);
      inputName.addEventListener('change',(e)=>{
        if(e.target.name === 'participant01_name') return;
        if(e.target.value !== ''){
          inputArray.push(e.target.name);
        }
        else{
          const deleteInput = inputArray.filter((items)=> items !== e.target.name);
          inputArray = deleteInput;
        }
        Counter();
      });
    });

    //削除

    /**
     * 入力エリアの削除処理
     * NOTE：削除のタイミングで値もリセット、参加者に値がある場合はCounterも更新
     */
    const clear = document.querySelectorAll('.js-clear-trigger');
    ;[...clear].map((el,i) => {
      el.addEventListener('click', _el => {
        const parent = _el.currentTarget.parentElement.parentElement;
        parent.classList.add('-hidden')

        //入力値の初期化
        const allInput = parent.querySelectorAll('input');
        allInput.forEach((items)=>{
          items.value = '';
        });

        //Counter用の配列から削除処理したinputも削除する
        const inputName = document.querySelector(`input[name="participant${String(i+2).padStart(2, '0')}_name"]`);
        const deleteInput = inputArray.filter((items)=> items !== inputName.name);
        inputArray = deleteInput;
        Counter();
      })
    })

    /**
     * 自動計算処理
     */
    const moreTrigger = document.querySelector('.js-more-trigger');
    const countMember = document.querySelectorAll('.js-count-member');
    const countMultiplication = document.querySelectorAll('.js-count-multiplication');
    const price = parseInt(moreTrigger.dataset.price);

    //初期表示（必須項目の参加者①は初期値1としてカウント）
    ;[...countMember].map(el => {
      if (el.querySelector('span')) el.querySelector('span').innerHTML = 1;
      if (el.querySelector('input')) el.querySelector('input').value = 1;
    })
    ;[...countMultiplication].map(el => {
      if (el.querySelector('span')) el.querySelector('span').innerHTML = price.toLocaleString();
      if (el.querySelector('input')) el.querySelector('input').value = price.toLocaleString();
    })

    function Counter(){
      const filteredInputArray = [...new Set(inputArray)];
      const counter = filteredInputArray.length;
      const priceNum = price * counter;
      const priceLocaleString = priceNum.toLocaleString()

      ;[...countMember].map(el => {
        if (el.querySelector('span')) el.querySelector('span').innerHTML = counter
        if (el.querySelector('input')) el.querySelector('input').value = counter
      })

      ;[...countMultiplication].map(el => {
        if (el.querySelector('span')) el.querySelector('span').innerHTML = priceLocaleString
        if (el.querySelector('input')) el.querySelector('input').value = priceLocaleString
      })
    };
  };


  // スムーズスクロール
  new SmoothScroll('a[href*="#"]', {
    clip: true,
    speed: 800,
    speedAsDuration: true,
    updateURL: false,
    emitEvents: true,
  })

  // スクロール前にナビを閉じる
  document.addEventListener('scrollStart', () => {
    Events.emit('NAV_CLOSE')
  }, false)

  // モーダル
  new Modal()

  // youtube
  ;[...document.querySelectorAll('.js-youtube')].map(el => {
    el.querySelector('.js-youtube-start').addEventListener('click', () => {
      new YouTubePlayer(el)
    })
  })

  // 前のページに戻るリンク
  ;[...document.querySelectorAll('.js-go-back')].map(el => {
    el.addEventListener('click', _el => {
      _el.preventDefault()
      window.history.back()
    })
  })

  // アコーディオン
  ;[...document.querySelectorAll('.js-content-trigger')].map(el => {
    el.addEventListener('click', _el => {
      const trigger = _el.currentTarget
      const nextEl = next(trigger)
      if (el.classList.contains('-open')) {
        slideStop(nextEl)
        slideUp(nextEl)
        el.classList.remove('-open')
      }
      else {
        slideStop(nextEl)
        slideDown(nextEl)
        el.classList.add('-open')
      }
    })
  })

  // フォームをエンターキーで送信するのを防ぐ
  ;[...document.getElementsByTagName('input')].map(el => {
    el.onkeypress = ev => {
      const key = ev.key
      if (key === 'Enter') ev.preventDefault()
    }
  })

  // エラー時にはフォームのアコーディオンを開いておく
  const errorEl = document.querySelectorAll('.p-form__box .error')
  if (errorEl.length) {
    ;[...document.querySelectorAll('.js-content-trigger')].map(el => {
      el.classList.add('-open')
      next(el).classList.remove('-d-none')
    })
  }

  // フォームの同意チェック
  // MW WP Formではショートコード以外のinputタグにJSの適用ができないのでbuttonタグで処理を代用
  const checkButton = document.querySelectorAll('.checkbox-button');
  checkButton.forEach((button)=>{
    button.addEventListener('click',(e)=>{
      const target = e.currentTarget;
      if(target.classList.contains('is-checked')){
        target.classList.remove('is-checked');
      }
      else{
        target.classList.add('is-checked');
      }
    });
  })

  const entryAgreeEl01 = document.querySelector('.js-entry-agree01')
  const entryAgreeEl02 = document.querySelector('.js-entry-agree02')
  const entryBtnEl = document.querySelector('.js-entry-btn')

  if (entryAgreeEl01 && entryAgreeEl02) {
    entryAgreeEl01.addEventListener('click', checkAgree)
    entryAgreeEl02.addEventListener('click', checkAgree)

    setTimeout(checkAgree, 1000)

    function checkAgree() {
      entryAgreeEl01.classList.contains('is-checked') && entryAgreeEl02.classList.contains('is-checked')
        ? entryBtnEl.classList.remove('-disable')
        : entryBtnEl.classList.add('-disable')
    }
  }
})